import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { CmsService, PageMetaConfig, PageMetaService, UnifiedInjector } from '@spartacus/core'

@Injectable({
  providedIn: 'root'
})
export class MbPageMetaService extends PageMetaService {

  constructor (cms: CmsService, unifiedInjector: UnifiedInjector, pageMetaConfig: PageMetaConfig,
               @Inject(PLATFORM_ID) platformId: string) {
    super(cms, unifiedInjector, pageMetaConfig, platformId)
  }

  protected getResolverMethods (): { [p: string]: string } {
    const resolvers = super.getResolverMethods()
    resolvers['robots'] = 'resolveRobots'
    resolvers['keywords'] = 'resolveKeywords'
    resolvers['description'] = 'resolveDescription'
    resolvers['title'] = 'resolveTitle'
    resolvers['metaTitle'] = 'resolveMetaTitle'
    resolvers['ogImage'] = 'resolveOGImage'
    resolvers['ogTitle'] = 'resolveOGTitle'
    resolvers['ogDescription'] = 'resolveOGDescription'
    resolvers['ogType'] = 'resolveOGType'
    resolvers['hreflang'] = 'resolveHrefLang'
    resolvers['canonicalUrl'] = 'resolveCanonicalUrl'
    resolvers['breadcrumbs'] = 'resolveBreadcrumbs'

    return resolvers
  }
}
